/* Maison Galet - Offre groupée: cart progress bar + live tier highlights */
(function () {
  'use strict';
  if (window.MGBundle) return;

  var cfg = window.MG_BUNDLE_CFG || {};
  var tiers = (cfg.tiers && cfg.tiers.length ? cfg.tiers : [{ q: 2, p: 15 }, { q: 3, p: 20 }, { q: 4, p: 25 }])
    .slice().sort(function (a, b) { return a.q - b.q; });

  var DURATION = 1100;
  var state = { count: parseInt(cfg.count, 10) || 0, shown: 0, timers: [] };

  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function pctLabel(p) { return '-' + p + ' %'; }
  function current(c) { var t = null; for (var i = 0; i < tiers.length; i++) if (c >= tiers[i].q) t = tiers[i]; return t; }
  function next(c) { for (var i = 0; i < tiers.length; i++) if (c < tiers[i].q) return tiers[i]; return null; }
  function remaining(k) { return k === 1 ? "plus qu’<strong>un article</strong>" : 'plus que <strong>' + k + ' articles</strong>'; }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  // evenly spaced milestones: tier i sits at (i+1)/n of the bar
  function position(c) {
    var n = tiers.length;
    if (c <= 0) return 0;
    var prevQ = 0, prevP = 0;
    for (var i = 0; i < n; i++) {
      var q = tiers[i].q, p = (i + 1) / n * 100;
      if (c < q) return prevP + (c - prevQ) / (q - prevQ) * (p - prevP);
      prevQ = q; prevP = p;
    }
    return 100;
  }

  function drawerMessage(c) {
    var cur = current(c), nx = next(c);
    if (!nx) return '<span class="mg-ok">' + CHECK + '<strong>' + pctLabel(cur.p) + ' débloqué</strong></span> sur votre commande, bravo !';
    var k = nx.q - c;
    if (!cur) return cap(remaining(k)) + ' pour débloquer <strong>' + pctLabel(nx.p) + '</strong>';
    return '<span class="mg-ok">' + CHECK + '<strong>' + pctLabel(cur.p) + ' débloqué</strong></span> · ' + remaining(k) + ' pour <strong>' + pctLabel(nx.p) + '</strong>';
  }

  function blockMessage(c, context) {
    var cur = current(c), nx = next(c);
    if (!nx) return '<span class="mg-ok">' + CHECK + '<strong>' + pctLabel(cur.p) + ' débloqué</strong></span> sur tout votre panier.';
    var k = nx.q - c;
    if (c <= 0) return 'Ajoutez <strong>' + nx.q + ' articles</strong> au panier pour profiter de <strong>' + pctLabel(nx.p) + '</strong>.';
    var have = 'Vous avez <strong>' + c + ' article' + (c > 1 ? 's' : '') + '</strong> au panier';
    if (context === 'product' && k === 1) return have + ' : ajoutez celui-ci pour <strong>' + pctLabel(nx.p) + '</strong>.';
    return have + ' : ajoutez-en ' + (k === 1 ? 'un autre' : k) + ' pour <strong>' + pctLabel(nx.p) + '</strong>.';
  }

  function renderBlocks() {
    var c = state.count, cur = current(c);
    var blocks = document.querySelectorAll('[data-mg-bundle]');
    for (var b = 0; b < blocks.length; b++) {
      var block = blocks[b];
      var cards = block.querySelectorAll('[data-mg-tier]');
      for (var i = 0; i < cards.length; i++) {
        var q = parseInt(cards[i].getAttribute('data-mg-tier'), 10);
        cards[i].classList.toggle('is-active', !!cur && cur.q === q);
      }
      var hint = block.querySelector('[data-mg-hint]');
      if (hint) hint.innerHTML = blockMessage(c, block.getAttribute('data-context'));
    }
  }

  function setMessage(el, html, animate) {
    if (!el || el.innerHTML === html) return;
    if (!animate) { el.innerHTML = html; return; }
    el.classList.add('is-swapping');
    setTimeout(function () { el.innerHTML = html; el.classList.remove('is-swapping'); }, 180);
  }

  function renderProgress(opts) {
    opts = opts || {};
    var root = document.querySelector('[data-mg-progress]');
    if (!root) return;
    var fill = root.querySelector('[data-mg-fill]');
    var nodes = root.querySelectorAll('[data-mg-node]');
    var c = state.count;
    var target = position(c);
    var start = opts.fromZero ? 0 : state.shown;
    var animate = opts.animate !== false;

    state.timers.forEach(clearTimeout);
    state.timers = [];

    setMessage(root.querySelector('[data-mg-msg]'), drawerMessage(c), animate);

    fill.style.transition = 'none';
    fill.style.width = (animate ? start : target) + '%';
    void fill.offsetWidth;
    fill.style.transition = '';
    if (animate) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { fill.style.width = target + '%'; });
      });
    }

    for (var i = 0; i < nodes.length; i++) {
      (function (node) {
        var q = parseInt(node.getAttribute('data-mg-node'), 10);
        var pos = parseFloat(node.getAttribute('data-pos'));
        var reached = c >= q;
        node.classList.remove('is-pop');
        if (!reached) { node.classList.remove('is-reached'); return; }
        if (!animate || pos <= start) { node.classList.add('is-reached'); return; }
        node.classList.remove('is-reached');
        // the fill eases out, so it passes each node early: sqrt curve
        var t = Math.sqrt(Math.max(0, (pos - start) / Math.max(1, target - start)));
        state.timers.push(setTimeout(function () {
          node.classList.add('is-reached', 'is-pop');
        }, Math.round(120 + t * DURATION * 0.75)));
      })(nodes[i]);
    }

    state.shown = target;
  }

  function setCount(c, opts) {
    c = parseInt(c, 10);
    if (isNaN(c)) return;
    var changed = c !== state.count;
    state.count = c;
    if (changed || (opts && opts.force)) {
      renderProgress(opts);
      renderBlocks();
    }
  }

  function refresh() {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function () {});
  }

  function drawerIsOpen(drawer) { return drawer.classList.contains('drawer--is-open'); }

  function init() {
    renderBlocks();
    renderProgress({ animate: false });

    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      // Impulse re-renders [data-products] from cart.ajax every time the cart changes
      var products = drawer.querySelector('[data-products]');
      if (products) {
        new MutationObserver(function () {
          var items = products.querySelector('[data-count]');
          if (items) setCount(items.getAttribute('data-count'), { animate: drawerIsOpen(drawer) });
        }).observe(products, { childList: true, subtree: true });
      }
      // replay the fill each time the drawer opens
      var wasOpen = drawerIsOpen(drawer);
      new MutationObserver(function () {
        var open = drawerIsOpen(drawer);
        if (open && !wasOpen) setTimeout(function () { renderProgress({ fromZero: true }); }, 260);
        wasOpen = open;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    ['cart:updated', 'ajaxProduct:added', 'cart:refresh', 'cart:change'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(refresh, 150); });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    refresh();
  }

  window.MGBundle = { refresh: refresh, setCount: setCount, tiers: tiers };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();